import img from '../assets/trustly_bank.png.js';
import img$1 from '../assets/trustly_bank_1.png.js';
import img$2 from '../assets/trustly_bank_2.png.js';
import img$3 from '../assets/trustly_bank_3.png.js';
import { formatPaymentLists } from '../utils/modernizePaymentUtils.js';
import { flipObject } from '../utils/utils.js';

const creditCardsFromCheckout = [
    {
        brand: 'VISA',
        pspIdentifier: '1111',
        pspIdentifierAlternative: null,
        psp: 'BRAINTREE',
        createdAt: null,
        bin: null,
        holderName: 'Eva longname Petlover',
        expirationMonth: '07',
        expirationYear: '2030',
        maskedNumber: '1111',
        expired: true,
        favorite: false,
        nonce: null,
    },
    {
        brand: 'MASTER_CARD',
        pspIdentifier: '1112',
        pspIdentifierAlternative: null,
        psp: 'ADYEN',
        createdAt: null,
        bin: null,
        holderName: 'John Smith',
        expirationMonth: '07',
        expirationYear: '2033',
        maskedNumber: '3456',
        expired: false,
        favorite: false,
        nonce: null,
    },
    {
        brand: 'MASTER_CARD',
        pspIdentifier: '1113',
        pspIdentifierAlternative: null,
        psp: 'ADYEN',
        createdAt: null,
        bin: null,
        holderName: 'Ben John',
        expirationMonth: '07',
        expirationYear: '2036',
        maskedNumber: '3893',
        expired: false,
        favorite: false,
        nonce: null,
    },
];
[
    { paymentMethod: 'CREDIT_CARD', cards: creditCardsFromCheckout.slice(0, 2) },
    { paymentMethod: 'BANCONTACT', cards: [creditCardsFromCheckout[2]] },
];
const issuers = [
    {
        issuerId: '271',
        issuerName: 'ING Bank Śląski (PIS)',
        issuerOrder: 1,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/271.png',
    },
    {
        issuerId: '15',
        issuerName: 'BLIK',
        issuerOrder: 2,
        logoUrl: '	https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/154.png',
    },
    {
        issuerId: '270',
        issuerName: 'mBank (PIS)',
        issuerOrder: 3,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/270.png',
    },
    {
        issuerId: '275',
        issuerName: 'Santander (PIS)',
        issuerOrder: 4,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/275.png',
    },
    {
        issuerId: '279',
        issuerName: 'Konto Inteligo (PIS)',
        issuerOrder: 5,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/279.png',
    },
    {
        issuerId: '85',
        issuerName: 'Bank Millennium',
        issuerOrder: 6,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/85.png',
    },
    {
        issuerId: '222',
        issuerName: 'NestPrzelew',
        issuerOrder: 7,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/222.png',
    },
    {
        issuerId: '99',
        issuerName: 'Pay with BOŚ',
        issuerOrder: 8,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/99.png',
    },
    {
        issuerId: '280',
        issuerName: 'Alior Bank (PIS)',
        issuerOrder: 9,
        logoUrl: 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/large/onlineBanking_PL/280.png',
    },
];
const iso3166CountryCodeMap = {
    BE: 'Belgium',
    CH: 'Switzerland',
    DE: 'Germany',
    FI: 'Finland',
    NL: 'Netherlands',
    PL: 'Poland',
    PT: 'Portugal',
    SE: 'Sweden',
};
flipObject(iso3166CountryCodeMap);
const countryToPaymentMethodMap = {
    BE: ['BM', 'BC', 'AP', 'K', 'VK', 'PP'],
    CH: ['TW', 'AP', 'K', 'PP', 'R', 'VK'],
    DE: ['BS', 'K', 'AP', 'PP', 'R', 'VK'],
    FI: ['PT', 'KL', 'KO', 'AP', 'K', 'PP', 'VK'],
    NL: ['ID', 'AP', 'K', 'VK', 'PP', 'R', 'BM', 'BC'],
    PL: ['OP', 'VK', 'CD', 'AP', 'K', 'PP'],
    PT: ['AP', 'K', 'CD', 'VK', 'PP', 'MB'],
    SE: ['TY', 'VK', 'KL', 'KO', 'AP', 'K', 'PP'],
};
const PAYMENT_METHOD_NAMES = {
    K: 'general.payment.credit_card',
    AP: 'general.payment.applepay',
    BC: 'general.payment.bancontact_card',
    BM: 'Appli mobile \n Payconiq by Bancontact',
    BS: 'general.payment.direct_debit_sepa',
    CD: 'general.payment.cashondelivery',
    DP: 'general.payment.dotpay',
    ID: 'general.payment.ideal',
    KL: 'general.payment.klarna_pay_later',
    KO: 'general.payment.klarna_pay_over_time',
    MB: 'general.payment.multibanco',
    OP: 'general.payment.online_banking_pl',
    PP: 'general.payment.paypal',
    PT: 'general.payment.paytrail',
    R: 'general.payment.invoice',
    TW: 'general.payment.twint',
    TY: 'general.payment.trustly',
    VK: 'general.payment.prepayment',
};
const PMConfig = {
    Adyen: {
        clientInfo: {
            pspName: 'ADYEN',
            pspToken: 'test_ORNCOIYKLJGFROSKKDM267OYGMGFV4XV',
        },
    },
    Bancontact: {
        clientInfo: {
            pspName: 'ADYEN',
            pspToken: '10001|CEA4D269C3ACAC4D6242A27D64B3A0B96B555BE9243B8EA7A11929A9BAF8078442DE085F7412A8F3929F73D2BEB3B9FBCD3C21889537D3FF1799EB18AE780EB45A4CA98C826103BE06B9EC335536E09DC8D5DDDCCDFAD7E88988DF679D472A49D0E76FDE95D49C12A0C8F09F6DC4BA34FB04F184A4A22EAB0D4B83F6B4A23ACC39C609BB381CD72A539B10BCE50482D8B4710404FF33766EB102F7C1BB0CEB3DA9ECAEFE7EE2D18135D4BAEEA73DBE6FE1B88C1FAE4BD90464081F452226433E6C9A8CEDF93B0000E1735BED8BB8C33C6C56E926E8D43607D9204851F184472ACF642D1B028DE4CC85A80A25A2EED759D71E1713C1BACD53F629AFA2D130C3BF',
        },
    },
    Braintree: {
        clientInfo: {
            pspName: 'BRAINTREE',
            pspToken: 'eyJ2ZXJzaW9uIjoyLCJhdXRob3JpemF0aW9uRmluZ2VycHJpbnQiOiJleUowZVhBaU9pSktWMVFpTENKaGJHY2lPaUpGVXpJMU5pSXNJbXRwWkNJNklqSXdNVGd3TkRJMk1UWXRjMkZ1WkdKdmVDSXNJbWx6Y3lJNkltaDBkSEJ6T2k4dllYQnBMbk5oYm1SaWIzZ3VZbkpoYVc1MGNtVmxaMkYwWlhkaGVTNWpiMjBpZlEuZXlKbGVIQWlPakUzTWpFM01UZzBNakFzSW1wMGFTSTZJakJsTjJFeE16Sm1MVGhsWkRFdE5EazNNUzA1WVRNMUxXVXpZVEF5TlRoaU5EWmhOQ0lzSW5OMVlpSTZJamxvTkhGNWNISjZjMk50TlhBeU16SWlMQ0pwYzNNaU9pSm9kSFJ3Y3pvdkwyRndhUzV6WVc1a1ltOTRMbUp5WVdsdWRISmxaV2RoZEdWM1lYa3VZMjl0SWl3aWJXVnlZMmhoYm5RaU9uc2ljSFZpYkdsalgybGtJam9pT1dnMGNYbHdjbnB6WTIwMWNESXpNaUlzSW5abGNtbG1lVjlqWVhKa1gySjVYMlJsWm1GMWJIUWlPbVpoYkhObGZTd2ljbWxuYUhSeklqcGJJbTFoYm1GblpWOTJZWFZzZENKZExDSnpZMjl3WlNJNld5SkNjbUZwYm5SeVpXVTZWbUYxYkhRaVhTd2liM0IwYVc5dWN5STZleUp0WlhKamFHRnVkRjloWTJOdmRXNTBYMmxrSWpvaVdtOXZjR3gxYzBsVUluMTkueWRxRkEtTlgzdDRkVjNMRGVQYzRPdVRxYnJHc3NmWjBCN1BiS05KUlc1LWpZUE1oQ0JUdnRSS3cxTTVBZWh5M0paUW9yMlAyUnJCOFNycGowTWlod1EiLCJjb25maWdVcmwiOiJodHRwczovL2FwaS5zYW5kYm94LmJyYWludHJlZWdhdGV3YXkuY29tOjQ0My9tZXJjaGFudHMvOWg0cXlwcnpzY201cDIzMi9jbGllbnRfYXBpL3YxL2NvbmZpZ3VyYXRpb24iLCJtZXJjaGFudEFjY291bnRJZCI6Ilpvb3BsdXNJVCIsImdyYXBoUUwiOnsidXJsIjoiaHR0cHM6Ly9wYXltZW50cy5zYW5kYm94LmJyYWludHJlZS1hcGkuY29tL2dyYXBocWwiLCJkYXRlIjoiMjAxOC0wNS0wOCIsImZlYXR1cmVzIjpbInRva2VuaXplX2NyZWRpdF9jYXJkcyJdfSwiY2xpZW50QXBpVXJsIjoiaHR0cHM6Ly9hcGkuc2FuZGJveC5icmFpbnRyZWVnYXRld2F5LmNvbTo0NDMvbWVyY2hhbnRzLzloNHF5cHJ6c2NtNXAyMzIvY2xpZW50X2FwaSIsImVudmlyb25tZW50Ijoic2FuZGJveCIsIm1lcmNoYW50SWQiOiI5aDRxeXByenNjbTVwMjMyIiwiYXNzZXRzVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhdXRoVXJsIjoiaHR0cHM6Ly9hdXRoLnZlbm1vLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJ2ZW5tbyI6Im9mZiIsImNoYWxsZW5nZXMiOltdLCJ0aHJlZURTZWN1cmVFbmFibGVkIjp0cnVlLCJhbmFseXRpY3MiOnsidXJsIjoiaHR0cHM6Ly9vcmlnaW4tYW5hbHl0aWNzLXNhbmQuc2FuZGJveC5icmFpbnRyZWUtYXBpLmNvbS85aDRxeXByenNjbTVwMjMyIn0sInBheXBhbEVuYWJsZWQiOmZhbHNlfQ==',
        },
    },
};
formatPaymentLists(countryToPaymentMethodMap, issuers, undefined, ['K', 'PP', 'AP'], ['VK', 'TW', 'R'], 'ADYEN', PMConfig);
const trustly_info = [
    'checkout.payment.trustly.info',
    'checkout.payment.trustly.info1',
    'checkout.payment.trustly.info2',
];
const legal_text = {
    AP: 'payment.applepay.full.description',
    CD: 'payment.cashondelivery.full.description',
    OP: 'payment.online_banking_pl.full.description',
    KL: 'payment.KL.full.description',
    KO: 'payment.KO.full.description',
    PP: 'payment.paypal.full.description',
    VK: 'payment.prepayment.full.description',
    TW: 'payment.twint.full.description',
    BANCONTACT_MOBILE: '',
    PT: '',
    DP: '',
    MB: '',
    R: '',
    ID: '',
};
const trustly_supported_banks = [img, img$1, img$2, img$3];
const payment_error_translations_map = {
    APPLEPAY_NOT_SUPPORTED: 'payment.applepay.not.supported',
    UNKNOWN_ERROR: 'payment.general.error.processing',
    'ZPPAPI-T-01': 'payment.technical.issues',
    'ZPPAPI-T-02': 'payment.technical.issues',
    'ZPPAPI-T-03': 'payment.technical.issues',
    'ZPPAPI-T-04': 'payment.technical.issues',
    'ZPPAPI-T-05': 'payment.technical.issues',
    'ZPPAPI-T-06': 'payment.technical.issues',
    CHECKOUT_PAYMENT_ERROR_NEWBANCONTACTCARDNEEDED: 'checkout.payment.bancontact.error.newcardneeded',
    CHECKOUT_PAYMENT_ERROR_NEWCREDITCARDNEEDED: 'checkout.payment.creditcard.error.newcardneeded',
    CHECKOUT_PAYMENT_ERROR_BANCONTACTCARDEXPIRED: 'checkout.payment.bancontact.error.expired',
    CHECKOUT_PAYMENT_ERROR_CREDITCARDEXPIRED: 'checkout.payment.creditcard.error.expired',
    CHECKOUT_PAYMENT_ERROR_ISSUERINVALID: 'checkout.payment.error.issuerinvalid',
    CHECKOUT_PAYMENT_ERROR_PREFERREDPAYMENTDISABLED: 'checkout.payment.error.preferred.payment.disabled',
};
const MOBILE_BREAKPOINT_UPTO_3_PM = 'mobile-breakpoint-upto-three-pm';
const MOBILE_BREAKPOINT_4_PM = 'mobile-breakpoint-four-pm';
const MOBILE_BREAKPOINT_MORETHAN_4_PM = 'mobile-breakpoint-morethan-four-pm';
const DESKTOP_BREAKPOINT_UPTO_5_PM = 'desktop-breakpoint-upto-five-pm';
const DESKTOP_BREAKPOINT_6_PM = 'desktop-breakpoint-six-pm';
const DESKTOP_BREAKPOINT_MORETHAN_6_PM = 'desktop-breakpoint-morethan-six-pm';
const DESKTOP_BREAKPOINT_MORETHAN_8_PM = 'desktop-breakpoint-morethan-eight-pm';
const APPLE_PAY_CONTAINER_ID = 'applepay-container';
const PAYMENT_SAVE_BUTTON_ID = 'payment-save-button';
const CLOSE_MODAL_BUTTON = 'Click_CloseModal';
const EVENTS_MAP = {
    Braintree_3DSWindow_Displayed: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'Braintree_3DSWindow',
            id: 'Braintree_3DSWindow_Displayed',
        },
    },
    Click_3DSCancel: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'Braintree_3DS_Modal',
            id: 'Click_3DSCancel',
        },
    },
    '3DSsubmitOK': {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_3DS_display',
            id: '3DSsubmitOK',
        },
    },
    '3DSsubmitKO': {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_3DS_display',
            id: '3DSsubmitKO',
        },
    },
    '3DSsubmitKObackend': {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_3DS_display',
            id: '3DSsubmitKObackend',
        },
    },
    force3DSchallenge: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_3DS_display',
            id: 'force3DSchallenge',
        },
    },
    AdyenFormOK: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'modernize_payment_component_Save_button',
            id: 'AdyenFormOK',
        },
    },
    AdyenFormKO: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'modernize_payment_component_Save_button',
            id: 'AdyenFormKO',
        },
    },
    PaymentSheetOpen: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'ApplePay_BuyButton',
            id: 'PaymentSheetOpen',
        },
    },
    PaymentSheetCloseOK: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'ApplePay_PaymentSheet',
            id: 'PaymentSheetCloseOK',
        },
    },
    PaymentSheetCloseKO: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'ApplePay_PaymentSheet',
            id: 'PaymentSheetCloseKO',
        },
    },
    Click_CloseModal: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'Braintree_3DS_error_Modal',
            id: CLOSE_MODAL_BUTTON,
        },
    },
    Click_PayPal_authoshipment_agreement: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'Click_PayPal_authoshipment_agreement',
            id: 'Click_PayPal_authoshipment_agreement',
        },
    },
    PaypalModalDisplayed: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'PayPal_Modal',
            id: 'PaypalModalDisplayed',
        },
    },
    PaypalModalNotDisplayed: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'PayPal_Modal',
            id: 'PaypalModalNotDisplayed',
        },
    },
    ['paypal agr KO']: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'PayPal_agreement_Err',
            id: 'paypal agr KO',
        },
    },
    ['paypal agr OK']: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'PayPal_agreement_OK',
            id: 'paypal agr OK',
        },
    },
    '3DSskipOK': {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_3DS_display',
            id: '3DSskipOK',
        },
    },
    subscriptionFirst: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_BuyButton',
            id: 'subscriptionFirst',
        },
    },
    cardType: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'Braintree_BuyButton',
            id: 'cardType',
        },
    },
    BTformKO: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'SaveUpdate_Payment_Button',
            id: 'BTformKO',
        },
    },
    BTformOK: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'SaveUpdate_Payment_Button',
            id: 'BTformOK',
        },
    },
    EditPaymentClick: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'edit_payment_method_icon_click',
            id: 'EditPaymentClick',
        },
    },
    ChangePaymentMethod: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        component: {
            name: 'modernize_payment_component_Save_button',
            id: 'Change payment method',
        },
    },
};

export { APPLE_PAY_CONTAINER_ID, CLOSE_MODAL_BUTTON, DESKTOP_BREAKPOINT_6_PM, DESKTOP_BREAKPOINT_MORETHAN_6_PM, DESKTOP_BREAKPOINT_MORETHAN_8_PM, DESKTOP_BREAKPOINT_UPTO_5_PM, EVENTS_MAP, MOBILE_BREAKPOINT_4_PM, MOBILE_BREAKPOINT_MORETHAN_4_PM, MOBILE_BREAKPOINT_UPTO_3_PM, PAYMENT_METHOD_NAMES, PAYMENT_SAVE_BUTTON_ID, PMConfig, countryToPaymentMethodMap, creditCardsFromCheckout, iso3166CountryCodeMap, issuers, legal_text, payment_error_translations_map, trustly_info, trustly_supported_banks };
//# sourceMappingURL=consts.js.map
